import React from 'react'
import dynamic from 'next/dynamic'

// Lazy load Code component to avoid loading prism-react-renderer on every page
// This reduces initial bundle size by ~100KB and improves TBT by ~200ms
const Code = dynamic(() => import('./Component.client').then((mod) => mod.Code), {
  ssr: true,
  loading: () => (
    <div className="bg-black p-4 border border-border rounded">
      <div className="animate-pulse h-24 bg-muted/20 rounded" />
    </div>
  ),
})

export type CodeBlockProps = {
  code: string
  language?: string
  blockType: 'code'
}

type Props = CodeBlockProps & {
  className?: string
}

export const CodeBlock: React.FC<Props> = ({ className, code, language }) => {
  return (
    <div className={[className, 'not-prose'].filter(Boolean).join(' ')}>
      <Code code={code} language={language} />
    </div>
  )
}
